import styled from "@emotion/styled";
import { Box, Typography, Button } from "@mui/material";
import { colors } from "../../theme/colors";

export const PatientsListCard = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const PatientsListHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const PatientsListTitle = styled(Typography)`
  font-family: Sora;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  color: ${colors.text.primary};
`;

export const TableContainer = styled(Box)`
  border-radius: 8px;
  padding: 0 16px;
  background: ${colors.background.secondary};
  overflow: auto;
  height: calc(100% - 60px);
`;

export const ErrorContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  text-align: center;
`;

export const ErrorText = styled(Typography)`
  color: #d32f2f;
  margin-bottom: 16px;
`;

export const RetryButton = styled(Button)`
  text-transform: none;
`;
export const DetailsLink = styled(Typography)`
  color: #3a8ab9;
  cursor: pointer;
  text-decoration: none;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
`;

export const EmptyStateImage = styled("img")`
  width: 200px;
  height: auto;
  margin-bottom: 24px;
`;

export const EmptyStateText = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
  color: ${colors.text.secondary};
  font-family: "Nunito", sans-serif;
`;
